import React from "react";

import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons/faInfoCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";

import { Modal } from "@mapmycustomers/ui";

import styles from "./NoSyncModal.module.scss";

interface Props {
  onGoToCalendarSettings: () => void;
  onHide: () => void;
}

const NoSyncModal: React.FC<Props> = ({ onGoToCalendarSettings, onHide }) => {
  const intl = useIntl();

  return (
    <Modal
      cancelText={intl.formatMessage({
        id: "dealRecord.addEventToNylasModal.noSyncModal.cancel",
        defaultMessage: "Not right now",
        description: "Cancel button title in a modal which appears when nylas sync is not set up",
      })}
      className={styles.container}
      closable={false}
      okText={intl.formatMessage({
        id: "dealRecord.addEventToNylasModal.noSyncModal.ok",
        defaultMessage: "Take me there",
        description: "Ok button title in modal which appears when nylas sync is not set up",
      })}
      onCancel={onHide}
      onOk={onGoToCalendarSettings}
      open
      title={null}
    >
      <div className={styles.content}>
        <FontAwesomeIcon className={styles.icon} icon={faInfoCircle} size="2x" />
        <div className={styles.text}>
          <div className={styles.title}>
            <span>
              {intl.formatMessage({
                id: "dealRecord.addEventToNylasModal.noSyncModal.title",
                defaultMessage: "You have not yet set up calendar sync",
                description: "Title of a modal which appears when nylas sync is not set up",
              })}
            </span>
          </div>
          <div className={styles.description}>
            {intl.formatMessage({
              id: "dealRecord.addEventToNylasModal.noSyncModal.text",
              defaultMessage: "You can set up calendar syncing from Calendar Settings",
              description: "Text in a modal which appears when nylas sync is not set up",
            })}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default NoSyncModal;
